export function formatToCurrency (number)
{
  
  let formatedNumber = parseFloat(Math.abs(number)).toLocaleString("es-US");
  
  // if(number < 0 )
  // {
  //   formatedNumber = parseFloat(Math.abs(number).toLocaleString("es-US"));
  // }
  if(formatedNumber?.includes("NaN"))
  {
    formatedNumber = parseFloat(0).toLocaleString("es-US");
  }
  if(!formatedNumber?.includes("."))
  {
    formatedNumber = `${formatedNumber}.00`;
  }
  else if(formatedNumber?.split(".")[1].length === 1)
  {
    formatedNumber = `${formatedNumber}0`
  }


  return number > 0 || formatedNumber === '0.00' ? formatedNumber : `-${formatedNumber}`;
}